import React, { createContext, useContext, useState } from "react";

// Stato di ricerca condiviso tra la barra nella topbar e la lista ricette.
// Il provider sta in wrapRootElement (gatsby-browser/ssr), quindi PERSISTE tra
// una navigazione e l'altra: la query non si perde cambiando pagina.
const SearchContext = createContext({
  query: "",
  setQuery: () => {},
  hasList: false,
  setHasList: () => {},
});

export const SearchProvider = ({ children }) => {
  const [query, setQuery] = useState("");
  // hasList = c'è una lista ricette montata nella pagina corrente (home/lista)?
  // Serve alla topbar per decidere se filtrare live o navigare alla lista.
  const [hasList, setHasList] = useState(false);
  return (
    <SearchContext.Provider value={{ query, setQuery, hasList, setHasList }}>
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = () => useContext(SearchContext);
